import React, { useState } from "react";
import {
  Button,
  Flex,
  Img,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Heading,
  Box,
} from "@chakra-ui/react";

const SocialMediaModal = ({
  isOpen,
  onClose,
  updateSocialMediaData,
  socialMedia,
}) => {
  const initValues = {
    facebook: socialMedia?.facebook ? socialMedia?.facebook : "",
    instagram: socialMedia?.instagram ? socialMedia?.instagram : "",
    twitter: socialMedia?.twitter ? socialMedia?.twitter : "",
    telegram: socialMedia?.telegram ? socialMedia?.telegram : "",
  };

  const [aboutData, setAboutData] = useState();
  const [facebookData, setFacebookData] = useState();
  const [instagramData, setInstagramData] = useState();
  const [twitterData, setTwitterData] = useState();
  const [telegramData, setTelegramData] = useState();
  const [formValues, setFormValues] = useState(initValues);
  const containerBgColor = useColorModeValue("#fff", "#081b2e");
  const inputBgColor = useColorModeValue("#F9FAFC", "#020b19");

  const inputStyles = {
    p: "20px",
    borderRadius: "10px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    w: "100%",
    color: "#697C94",
  };

  const btnStyle = {
    p: "5px 10px",
    alignItems: "center",
    borderRadius: "5px",
    color: "#fff",
    direction: "row",
    cursor: "pointer",
    w: "30%",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSocialMediaData = () => {
    updateSocialMediaData(formValues);
    onClose();
  };

  return (
    <>
      <Modal id="groupModal" isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent bg={containerBgColor}>
          <ModalHeader></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
              <Heading fontSize={"1.5em"}>Social Media</Heading>
            </Flex>

            <Stack direction={"column"} alignItems="center" mb={"2em"}>
              <Text color={"#0076FF"}>Facebook</Text>
              <Input
                {...inputStyles}
                name="facebook"
                value={formValues?.facebook}
                onChange={handleChange}
              />
            </Stack>

            <Stack direction={"column"} alignItems="center" mb={"2em"}>
              <Text color={"#0076FF"}>Instagram</Text>
              <Input
                {...inputStyles}
                name="instagram"
                value={formValues?.instagram}
                onChange={handleChange}
              />
            </Stack>

            <Stack direction={"column"} alignItems="center" mb={"2em"}>
              <Text color={"#0076FF"}>X</Text>
              <Input
                {...inputStyles}
                name="twitter"
                value={formValues?.twitter}
                onChange={handleChange}
              />
            </Stack>

            <Stack direction={"column"} alignItems="center" mb={"2em"}>
              <Text color={"#0076FF"}>Telegram</Text>
              <Input
                {...inputStyles}
                name="telegram"
                value={formValues?.telegram}
                onChange={handleChange}
              />
            </Stack>

            <Flex justifyContent="center" alignItems="center" mb={"2em"}>
              <Button
                bg="#07900C"
                {...btnStyle}
                onClick={handleSocialMediaData}
              >
                Submit
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default SocialMediaModal;
